import axios from '../../plugins/axios';
import { Message } from 'element-ui';

export const bills_module = {
    state: ()=>({
        pending: false,
        loadingMore: false,
        data: {
            current_page: 1,
            data: [],
            last_page: null,
            searchedKeyword:'',
        },
        message: null,
        success: null,
        error: null
    }),
    mutations: {
        fetch_bills_request(state,loadingType){

            if(loadingType == 'new'){

                state.pending = true;

            }else if(loadingType == 'more'){

                state.loadingMore = true;

            }

        },
        fetch_bills_success(state, payload){

            if(payload.loadData == 'new'){

                state.data.data = payload.bill.data

            }else if(payload.loadData == 'more'){

                state.data.data.push(...payload.bill.data);

            }

            state.data.current_page = payload.bill.current_page
            state.data.last_page = payload.bill.last_page
            state.pending = false;
            state.loadingMore = false;
            state.success = true;
            state.error = null;
            state.message = payload.message;

        },
        fetch_bills_failure(state, payload){

            state.data.data = [];
            state.pending = false;
            state.loadingMore = false;
            state.success = false;
            state.error = payload.error;
            state.message = payload.message

        },
        add_bills_list(state,payload){

            state.data.data.unshift(payload);

        },
        update_bills_list(state,payload){

            const index = state.data.data.findIndex(x=>x.id === payload.id)
  
            if(index !== -1){

                state.data.data[index] = payload;
                
            }

        },
        delete_bills_list(state,payload){

            state.data.data.splice(payload,1);

        },
        bills_bulk_action(state,payload){

            if(payload.action == 'delete'){

                state.data.data = state.data.data.filter((bill)=>{

                    if(!payload.listIds.includes(bill.id)){

                        return bill;

                    }

                });

            }

        },
        update_searched_keyword(state,payload){

            state.data.searchedKeyword = payload.keyword

        },
        remove_searched_keyword(state){

            state.data.searchedKeyword = ''

        },
        CLEAR_MODULE(state){

            state.pending = false
            state.loadingMore = false;
            state.message = null
            state.success = null
            state.error = null

            state.data.current_page = 1
            state.data.data = []
            state.data.last_page = null,
            state.data.searchedKeyword= ''

        }
    },
    actions:{
        async fetchStoreBillsRequest({commit},{size, page, loadData}){

            commit('fetch_bills_request',loadData);

            const searchedKeyword = this.state.bills_module.data.searchedKeyword;

            try{
                let res = await axios.get('/getBills',{
                    params:{
                        search: searchedKeyword.length > 0 ? searchedKeyword : null,
                        offset:size,
                        page:page
                    }
                });
                if(res.data.status_code == '1056'){

                    res.data.loadData = loadData

                    commit('fetch_bills_success', res.data)

                }
            }catch(ex){

                Message({
                    type: 'error',
                    showClose: true,
                    message: ex.response ? ex.response.data.message : ex.message,
                });

                commit('fetch_bills_failure', {error: ex, message: ex})
                
            }
            
        }
    },
    getters: {
        bills(state){

            return state.data.data;

        },
        isPending(state){

            return state.pending;

        },
        isLoadingMore(state){

            return state.loadingMore;

        },
        currentPage(state){

            return state.data.current_page;

        },
        lastPage(state){

            return state.data.last_page;

        },
        keyword(state){

            return state.data.searchedKeyword;

        },
        message(state){

            return state.message;
            
        },
        error:(state)=>state.error
    }
}